import React from "react";
import * as styles from "./CTABar.module.css";
import {
  ComponentProps,
  KontentRichText,
  LeftRight,
  Vector,
} from "../../../types/index";
import { Cta, LinkCtaProps } from "../../elements/Cta/Cta";
import { CTAStyles } from "./index";
import { SectionWrapper } from "../../containers/SectionWrapper";
import { CustomRichTextElement } from "../../elements/CustomRichTextElement/CustomRichTextElement";

interface Props extends ComponentProps {
  heading: KontentRichText;
  cta: LinkCtaProps;
  style: CTAStyles;
  vector?: Vector;
  vectorPlacement?: LeftRight;
}

export const CTABar: React.FC<Props> = ({
  heading,
  style,
  cta,
  vector,
  vectorPlacement,
  ...props
}) => {
  const classes = [styles.CTABar];

  if (style === "white_background") {
    classes.push(styles.whiteBackground);
  }

  const vectorClasses = [styles.vector];
  if (vectorPlacement === "left") {
    vectorClasses.push(styles.left);
  }

  return (
    <SectionWrapper {...props}>
      <div className={classes.join(" ")}>
        <div className={styles.content}>
          {heading && (
            <div
              className={styles.heading}
              data-kontent-element-codename="heading"
            >
              <CustomRichTextElement content={heading} />
            </div>
          )}
          <div data-kontent-element-codename="link_configuration__link">
            <Cta {...cta} />
          </div>
        </div>
        {vector?.item && (
          <div className={vectorClasses.join(" ")}>
            <img src={vector?.item?.url} alt={vector.alt} />
          </div>
        )}
      </div>
    </SectionWrapper>
  );
};
